import React from 'react';
import AuthImage from './AuthImage';
import surveyApi from '../surveyApi';

// Renders a question's attached image (from config.image) at its configured
// width % and alignment. If `localSrc` is given (a not-yet-uploaded preview,
// e.g. an object URL), it is used directly instead of the auth-gated server URL.
// Returns null when there is neither a stored image nor a local preview.
export default function QuestionImage({ surveyId, question, localSrc }) {
  const img = (question && question.config && question.config.image) || {};
  const hasServer = !!img.filename;
  if (!localSrc && !hasServer) return null;

  const width = Math.min(100, Math.max(5, Number(img.width_pct) || 100));
  const align = img.align || 'center';
  const justify = align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';
  const imgStyle = { width: `${width}%`, maxWidth: '100%', height: 'auto' };

  return (
    <div className="my-3 flex" style={{ justifyContent: justify }}>
      {localSrc ? (
        <img src={localSrc} alt={img.alt || ''} className="rounded-lg border border-slate-700" style={imgStyle} />
      ) : (
        <AuthImage
          url={surveyApi.questionImageUrl(surveyId, question.id, img.filename)}
          alt={img.alt || ''}
          className="rounded-lg border border-slate-700"
          style={imgStyle}
        />
      )}
    </div>
  );
}
